  // ── Tab switching ─────────────────────────────────────────────────────────
  function switchTab(name) {
    document.querySelectorAll('.tab-panel').forEach(p => p.classList.remove('active'));
    document.querySelectorAll('.tab-btn').forEach(b => b.classList.remove('active'));
    document.getElementById('tab-' + name).classList.add('active');
    document.querySelectorAll('.tab-btn').forEach(b => {
      if (b.getAttribute('onclick').includes(name)) b.classList.add('active');
    });
  }

  // ── Phone helpers ─────────────────────────────────────────────────────────
  function parsePhone(raw) {
    if (!raw) return { base: '', ext: '' };
    const extMatch = raw.match(/\s*(?:ext\.?|x|#)\s*(\d+)\s*$/i);
    if (extMatch) return { base: raw.slice(0, extMatch.index).trim(), ext: extMatch[1] };
    return { base: raw.trim(), ext: '' };
  }
  function buildTelHref(base, ext) {
    const digits = base.replace(/[^\d+]/g, '');
    if (!digits) return '';
    return ext ? `tel:${digits};ext=${ext}` : `tel:${digits}`;
  }
  function formatPhoneDisplay(base, ext) {
    if (!base) return '';
    return ext ? `${base} ext. ${ext}` : base;
  }

  // ── Values (builder) ──────────────────────────────────────────────────────
  function getValues() {
    const rawPhone = document.getElementById('phone').value.trim();
    const rawExt   = document.getElementById('ext').value.trim().replace(/[^\d]/g, '');
    const parsed   = parsePhone(rawPhone);
    const ext      = rawExt || parsed.ext;
    const base     = parsed.base;
    return {
      name:         document.getElementById('name').value.trim()       || 'First Last',
      title:        document.getElementById('title').value.trim()      || 'Job Title',
      department:   document.getElementById('department').value.trim(),
      base, ext,
      telHref:      buildTelHref(base, ext),
      phoneDisplay: formatPhoneDisplay(base, ext),
      email:        document.getElementById('email').value.trim()      || '',
      hours:        document.getElementById('hours').value.trim(),
      impactUrl:    document.getElementById('impactUrl').value.trim(),
      impactText:   document.getElementById('impactText').value.trim(),
      seasonImg:    document.getElementById('seasonImg').value.trim(),
      seasonText:   document.getElementById('seasonText').value.trim(),
    };
  }

  // ── Escape ────────────────────────────────────────────────────────────────
  function esc(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  // ── Build signature HTML ──────────────────────────────────────────────────
  function buildSignatureHTML(v) {
    const company = v.department
      ? `${esc(v.department)} | TradeMutt`
      : 'TradeMutt';
    const phoneRow = v.base ? `
                    <tr height="25" style="vertical-align:middle;">
                      <td width="30" style="vertical-align:middle;"><span style="display:block;"><img src="https://cdn.shopify.com/s/files/1/0262/0820/6932/files/51719004463_ccc0d332d5_t.jpg" width="13" style="display:block;" alt=""></span></td>
                      <td style="padding:0;"><a href="${esc(v.telHref)}" style="text-decoration:none;color:#161616;font-size:12px;">${esc(v.phoneDisplay)}</a></td>
                    </tr>` : '';
    const emailRow = v.email ? `
                    <tr height="25" style="vertical-align:middle;">
                      <td width="30" style="vertical-align:middle;"><span style="display:block;"><img src="https://cdn.shopify.com/s/files/1/0262/0820/6932/files/51719407494_beac95d54e_t.jpg" width="13" style="display:block;" alt=""></span></td>
                      <td style="padding:0;"><a href="mailto:${esc(v.email)}" style="text-decoration:none;color:#161616;font-size:12px;">${esc(v.email)}</a></td>
                    </tr>` : '';
    const hasSeasonal = v.seasonImg || v.seasonText;
    const seasonalRows = hasSeasonal ? `
    <tr>
      <td style="padding-bottom:10px;vertical-align:middle;white-space:normal;">${
        v.seasonImg ? `<img src="${esc(v.seasonImg)}" height="28" style="display:inline-block;vertical-align:middle;margin-right:8px;" alt="">` : ''
      }<strong style="font-size:14px;color:#161616;font-family:'Trebuchet MS',Arial,sans-serif;vertical-align:middle;">${esc(v.seasonText)}</strong></td>
    </tr>
    <tr>
      <td style="border-bottom:1px solid #ebab00;height:1px;font-size:0;line-height:0;">&nbsp;</td>
    </tr>
    <tr><td height="16" style="font-size:0;line-height:0;">&nbsp;</td></tr>` : '';
    const hoursRow = v.hours ? `
            <tr>
              <td style="padding-bottom:12px;font-size:12px;color:#161616;font-family:'Trebuchet MS',Arial,sans-serif;">
                Available: ${esc(v.hours)}
              </td>
            </tr>` : '';
    const impactRow = (v.impactUrl && v.impactText) ? `
            <tr>
              <td style="padding-top:10px;">
                <a href="${esc(v.impactUrl)}" style="color:#ebab00;font-size:12px;font-weight:700;font-family:'Trebuchet MS',Arial,sans-serif;text-decoration:none;">${esc(v.impactText)} &#8594;</a>
              </td>
            </tr>` : '';
    return `<table cellpadding="0" cellspacing="0" style="min-width:450px;max-width:100%;vertical-align:-webkit-baseline-middle;font-size:medium;font-family:'Trebuchet MS',Arial,sans-serif;">
  <tbody>${seasonalRows}
    <tr>
      <td>
        <table cellpadding="0" cellspacing="0" style="max-width:100%;vertical-align:-webkit-baseline-middle;font-size:medium;font-family:'Trebuchet MS',Arial,sans-serif;">
          <tbody>
            <tr>
              <td width="80" style="vertical-align:middle;">
                <span style="margin-right:20px;display:block;">
                  <img src="https://cdn.shopify.com/s/files/1/0262/0820/6932/files/Shield_regular_2.png" role="presentation" width="80" style="max-width:80px;display:block;" alt="TradeMutt">
                </span>
              </td>
              <td style="vertical-align:middle;">
                <h3 style="margin:0;font-size:18px;color:#161616;">${esc(v.name)}</h3>
                <p style="margin:0;color:#161616;font-size:14px;line-height:22px;">${esc(v.title)}</p>
                <p style="margin:0;font-weight:500;color:#161616;font-size:14px;line-height:22px;">${company}</p>
              </td>
              <td width="30"><div style="width:30px;"></div></td>
              <td style="width:1px;border-bottom:none;border-left:1px solid #ebab00;">&nbsp;</td>
              <td width="30"><div style="width:30px;"></div></td>
              <td style="vertical-align:middle;">
                <table cellpadding="0" cellspacing="0" style="vertical-align:-webkit-baseline-middle;font-size:medium;font-family:'Trebuchet MS',Arial,sans-serif;">
                  <tbody>${phoneRow}${emailRow}
                    <tr height="25" style="vertical-align:middle;">
                      <td width="30" style="vertical-align:middle;"><span style="display:block;"><img src="https://cdn.shopify.com/s/files/1/0262/0820/6932/files/51718747741_897e5af927_t.jpg" width="13" style="display:block;" alt=""></span></td>
                      <td style="padding:0;"><a href="https://www.trademutt.com" style="text-decoration:none;color:#161616;font-size:12px;">TradeMutt.com</a></td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </td>
    </tr>
    <tr><td height="20" style="font-size:0;line-height:0;">&nbsp;</td></tr>
    <tr><td style="border-bottom:1px solid #ebab00;height:1px;font-size:0;line-height:0;">&nbsp;</td></tr>
    <tr><td height="20" style="font-size:0;line-height:0;">&nbsp;</td></tr>${hoursRow}
    <tr>
      <td>
        <table cellpadding="0" cellspacing="0" style="max-width:100%;width:100%;font-family:'Trebuchet MS',Arial,sans-serif;">
          <tbody>
            <tr>
              <td style="vertical-align:top;">
                <a href="https://www.tiacs.org/">
                  <img src="https://cdn.shopify.com/s/files/1/0262/0820/6932/files/51719670510_1ec3d27b7b_z.jpg" alt="TIACS alliance member" role="presentation" width="280" style="max-width:280px;display:inline-block;">
                </a>
              </td>
              <td style="text-align:right;vertical-align:top;">
                <table cellpadding="0" cellspacing="0" style="display:inline-block;">
                  <tbody>
                    <tr>
                      <td><a href="https://www.facebook.com/Trademutt" style="display:inline-block;padding:0;"><img src="https://cdn.shopify.com/s/files/1/0262/0820/6932/files/51719621815_4978f99615_t.jpg" alt="Facebook" height="24" style="max-width:135px;display:block;"></a></td>
                      <td width="5">&nbsp;</td>
                      <td><a href="https://www.linkedin.com/company/trademutt/" style="display:inline-block;padding:0;"><img src="https://cdn.shopify.com/s/files/1/0262/0820/6932/files/51719004478_65c341a7a8_t.jpg" alt="LinkedIn" height="24" style="max-width:135px;display:block;"></a></td>
                      <td width="5">&nbsp;</td>
                      <td><a href="https://www.instagram.com/trademutt/" style="display:inline-block;padding:0;"><img src="https://cdn.shopify.com/s/files/1/0262/0820/6932/files/51718747801_0a127a7b8b_t.jpg" alt="Instagram" height="24" style="max-width:135px;display:block;"></a></td>
                      <td width="5">&nbsp;</td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>${impactRow}
          </tbody>
        </table>
      </td>
    </tr>
  </tbody>
</table>`;
  }

  // ── Render (builder) ──────────────────────────────────────────────────────
  function update() {
    const v = getValues();
    const html = buildSignatureHTML(v);
    document.getElementById('previewBox').innerHTML = html;
    document.getElementById('codeOutput').textContent = html;
  }

  // ── Copy / Save (builder) ─────────────────────────────────────────────────
  function flash(id, label, successLabel) {
    const btn = document.getElementById(id);
    btn.textContent = successLabel;
    btn.classList.add('copied');
    setTimeout(() => { btn.textContent = label; btn.classList.remove('copied'); }, 2200);
  }
  function copyForHubSpot() {
    navigator.clipboard.writeText(buildSignatureHTML(getValues())).then(() => flash('btnCopyHub', 'Copy for HubSpot', 'Copied!'));
  }
  function copyCode() {
    navigator.clipboard.writeText(buildSignatureHTML(getValues())).then(() => {
      const btn = document.getElementById('btnCopyCode');
      btn.textContent = 'Copied!';
      btn.classList.add('copied');
      setTimeout(() => { btn.textContent = 'Copy'; btn.classList.remove('copied'); }, 2000);
    });
  }
  function copyForGmail() {
    const html = buildSignatureHTML(getValues());
    const wrapped = `<!DOCTYPE html><html><body>${html}</body></html>`;
    if (!window.ClipboardItem) {
      alert('Copy for Gmail requires Chrome or Edge. Use "Copy for HubSpot" or try a Chromium browser.');
      return;
    }
    const blob = new Blob([wrapped], { type: 'text/html' });
    navigator.clipboard.write([new ClipboardItem({ 'text/html': blob })])
      .then(() => flash('btnGmail', 'Copy for Gmail', 'Copied!'))
      .catch(() => alert('Clipboard access was blocked. Make sure you\'re using Chrome or Edge, and that this page has permission to access your clipboard.'));
  }
  function saveAsHTML() {
    const v = getValues();
    const html = buildSignatureHTML(v);
    const blob = new Blob([html], { type: 'text/html' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = safeFilename(v.name, v.title);
    a.click();
    URL.revokeObjectURL(url);
    flash('btnSave', 'Save HTML', 'Saved!');
  }

  // Wire up builder inputs
  ['name','title','department','phone','ext','email','hours','impactUrl','impactText','seasonImg','seasonText'].forEach(id => {
    document.getElementById(id).addEventListener('input', update);
  });
  update();

  // ── CSV parser ────────────────────────────────────────────────────────────
  function parseCSVLine(line) {
    const result = [];
    let current = '';
    let inQuotes = false;
    for (let i = 0; i < line.length; i++) {
      const ch = line[i];
      if (ch === '"') {
        if (inQuotes && line[i + 1] === '"') { current += '"'; i++; }
        else inQuotes = !inQuotes;
      } else if (ch === ',' && !inQuotes) {
        result.push(current);
        current = '';
      } else {
        current += ch;
      }
    }
    result.push(current);
    return result;
  }
  function parseCSV(text) {
    const lines = text.replace(/\r\n/g, '\n').replace(/\r/g, '\n').trim().split('\n');
    if (lines.length < 2) return [];
    const headers = parseCSVLine(lines[0]).map(h => h.trim().toLowerCase().replace(/\s+/g, '_'));
    const rows = [];
    for (let i = 1; i < lines.length; i++) {
      const line = lines[i].trim();
      if (!line) continue;
      const vals = parseCSVLine(line);
      const row = {};
      headers.forEach((h, idx) => { row[h] = (vals[idx] || '').trim(); });
      rows.push(row);
    }
    return rows;
  }
  function buildValuesFromRow(row) {
    const rawPhone = (row.phone || '').trim();
    const rawExt   = ((row.ext || '').trim()).replace(/[^\d]/g, '');
    const parsed   = parsePhone(rawPhone);
    const ext      = rawExt || parsed.ext;
    const base     = parsed.base;
    const impactUrl = (row.impact_url || '').trim() || 'https://trademutt.com/pages/impact-calculator';
    return {
      name:         (row.name    || 'Unknown').trim(),
      title:        (row.title   || '').trim(),
      department:   (row.department || '').trim(),
      base, ext,
      telHref:      buildTelHref(base, ext),
      phoneDisplay: formatPhoneDisplay(base, ext),
      email:        (row.email   || '').trim(),
      hours:        (row.hours   || '').trim(),
      impactUrl,
      impactText:   (row.impact_text   || '').trim(),
      seasonImg:    (row.seasonal_img  || '').trim(),
      seasonText:   (row.seasonal_text || '').trim(),
    };
  }
  function safeFilename(name, title) {
    const n = (name || 'Unknown').trim().replace(/[^a-zA-Z0-9]/g, '_');
    const t = (title || '').trim().replace(/[^a-zA-Z0-9]/g, '_');
    return t ? `TM_${n}_${t}.html` : `TM_${n}.html`;
  }

  // ── Bulk: parse and preview ───────────────────────────────────────────────
  let bulkRows = [];
  function parseAndPreview() {
    const fileInput = document.getElementById('csvFile');
    const paste     = document.getElementById('csvPaste').value.trim();
    if (fileInput.files.length > 0) {
      const reader = new FileReader();
      reader.onload = e => renderBulkPreview(e.target.result);
      reader.readAsText(fileInput.files[0]);
    } else if (paste) {
      renderBulkPreview(paste);
    } else {
      alert('Paste CSV text or upload a CSV file first.');
    }
  }
  function renderBulkPreview(text) {
    bulkRows = parseCSV(text);
    const container = document.getElementById('bulkPreview');
    const actions   = document.getElementById('bulkActions');
    const countEl   = document.getElementById('bulkCount');
    if (!bulkRows.length) {
      container.innerHTML = '<div class="empty-state"><span>⚠️</span>No valid rows found. Check your CSV format.</div>';
      actions.style.display = 'none';
      return;
    }
    const validCount = bulkRows.filter(r => r.name && r.title && r.email).length;
    countEl.textContent = `${validCount} of ${bulkRows.length} rows valid`;
    actions.style.display = 'flex';
    let html = `<table class="preview-table">
      <thead><tr>
        <th>#</th>
        <th>Name</th>
        <th>Title</th>
        <th>Email</th>
        <th>Dept</th>
        <th>Filename</th>
        <th></th>
      </tr></thead>
      <tbody>`;
    bulkRows.forEach((row, i) => {
      const missing = [];
      if (!row.name)  missing.push('name');
      if (!row.title) missing.push('title');
      if (!row.email) missing.push('email');
      const isError = missing.length > 0;
      const rowClass = isError ? ' class="row-error"' : '';
      const errorBadge = isError ? missing.map(m => `<span class="error-badge">missing: ${m}</span>`).join(' ') : '';
      html += `<tr${rowClass}>
        <td style="color:#aaa;font-size:11px;">${i + 1}</td>
        <td>${esc(row.name || '')}${errorBadge}</td>
        <td>${esc(row.title || '')}</td>
        <td>${esc(row.email || '')}</td>
        <td>${esc(row.department || '')}</td>
        <td style="font-size:11px;color:#888;">${esc(safeFilename(row.name || 'unknown', row.title || ''))}</td>
        <td>${isError ? '' : `<button class="btn-dl" onclick="downloadRow(${i})">Download</button>`}</td>
      </tr>`;
    });
    html += '</tbody></table>';
    container.innerHTML = html;
  }
  function downloadRow(idx) {
    const v    = buildValuesFromRow(bulkRows[idx]);
    const html = buildSignatureHTML(v);
    triggerDownload(html, safeFilename(v.name, v.title));
  }
  function triggerDownload(html, filename) {
    const blob = new Blob([html], { type: 'text/html' });
    const url  = URL.createObjectURL(blob);
    const a    = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(url);
  }
  async function downloadAllZip() {
    const valid = bulkRows.filter(r => r.name && r.title && r.email);
    if (!valid.length) { alert('No valid rows to download.'); return; }
    const btn = document.getElementById('btnZip');
    btn.disabled = true;
    btn.textContent = 'Building ZIP…';
    // Load JSZip on demand
    if (!window.JSZip) {
      await new Promise((resolve, reject) => {
        const s = document.createElement('script');
        s.src = 'https://cdnjs.cloudflare.com/ajax/libs/jszip/3.10.1/jszip.min.js';
        s.onload = resolve;
        s.onerror = reject;
        document.head.appendChild(s);
      });
    }
    const zip = new JSZip();
    valid.forEach(row => {
      const v    = buildValuesFromRow(row);
      const html = buildSignatureHTML(v);
      zip.file(safeFilename(v.name, v.title), html);
    });
    const blob = await zip.generateAsync({ type: 'blob' });
    const today = new Date().toISOString().slice(0, 10);
    triggerDownload(blob, `TradeMutt_Signatures_${today}.zip`);
    btn.disabled = false;
    btn.textContent = 'Download All as ZIP';
  }

  // File input auto-parse on selection
  document.getElementById('csvFile').addEventListener('change', function() {
    if (this.files.length > 0) {
      const reader = new FileReader();
      reader.onload = e => {
        document.getElementById('csvPaste').value = '';
        renderBulkPreview(e.target.result);
      };
      reader.readAsText(this.files[0]);
    }
  });

  // ── Sample CSV ────────────────────────────────────────────────────────────
  function downloadSampleCSV() {
    const csv = [
      'name,title,email,department,phone,ext,hours,impact_text,impact_url,seasonal_img,seasonal_text',
      'John Smith,Site Manager,john.smith@trademutt.com,Operations,0400 000 000,,Mon-Fri 7am-4pm AEST,See your positive social impact,,,',
      'Sarah Jones,Account Manager,sarah.jones@trademutt.com,Sales,0411 111 111,201,Mon-Fri 8am-5pm AEST,See your positive social impact,,,'
    ].join('\n');
    const blob = new Blob([csv], { type: 'text/csv' });
    const url  = URL.createObjectURL(blob);
    const a    = document.createElement('a');
    a.href = url;
    a.download = 'TradeMutt_Signatures_Template.csv';
    a.click();
    URL.revokeObjectURL(url);
  }
